import React from 'react';
import './TabletSuccMessage.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import useApp from '../../AppContext';
function TabletSuccMessage({ title, paragraph, btnSuccessScreen }) {
    const app = useApp();
    return (
        <div className='wrapper-succ-message'>
            <img src={app.theme === 'dark' ? '/images/Tablet-Succ-Screen-Dark.png' : '/images/Tablet-Succ-Screen.png'} alt='Success Icon' />
            <h1>{title}</h1>
            <p>{paragraph}</p>
            <button className="btn-tablet-success" onClick={() => window.location.reload()}>
                <i className="animation"></i>{btnSuccessScreen}<i className="animation"></i>
            </button>
        </div>
    );
}

export default TabletSuccMessage;
